import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { LANGS, translate, translateModel } from '@/lib/i18n';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem('jw_lang') || 'en');

  const applyDir = useCallback((code) => {
    const meta = LANGS.find((l) => l.code === code) || LANGS[0];
    const root = document.documentElement;
    root.setAttribute('lang', meta.code);
    root.setAttribute('dir', meta.dir);
  }, []);

  useEffect(() => {
    applyDir(lang);
    localStorage.setItem('jw_lang', lang);
  }, [lang, applyDir]);

  const setLang = (code) => setLangState(code);
  const toggle = () => setLangState((c) => (c === 'ar' ? 'en' : 'ar'));

  const t = useCallback((key, fallback) => translate(lang, key, fallback), [lang]);
  const tModel = useCallback((value) => translateModel(lang, value), [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t, tModel, langs: LANGS }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
